(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  const initReelsNav = () => {
    console.log("Reels navigation initialized.");
    const wrappers = document.querySelectorAll('.reels__wrapper');
    
    wrappers.forEach((wrapper, index) => {
      const grid = wrapper.querySelector('.reels__grid--carousel');
      const leftBtn = wrapper.querySelector('.reels__nav--left');
      const rightBtn = wrapper.querySelector('.reels__nav--right');
      
      console.log(`Wrapper ${index}: grid found:`, !!grid, `leftBtn found:`, !!leftBtn, `rightBtn found:`, !!rightBtn);
      
      if (!grid || !leftBtn || !rightBtn) return;
      
      const updateNavButtons = () => {
        const scrollLeft = grid.scrollLeft;
        const maxScroll = grid.scrollWidth - grid.clientWidth;
        
        leftBtn.disabled = scrollLeft <= 5;
        rightBtn.disabled = scrollLeft >= maxScroll - 5;
      };
      
      leftBtn.addEventListener('click', () => {
        console.log("Left button clicked.");
        const card = grid.querySelector('.reels__card');
        const scrollAmount = card ? card.clientWidth + 24 : grid.clientWidth;
        
        // Temporarily disable scroll snapping to avoid scroll snapping fights during programmatic smooth scrolls
        grid.style.scrollSnapType = 'none';
        grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        
        setTimeout(() => {
          grid.style.scrollSnapType = 'x mandatory';
        }, 500);
      });
      
      rightBtn.addEventListener('click', () => {
        console.log("Right button clicked.");
        const card = grid.querySelector('.reels__card');
        const scrollAmount = card ? card.clientWidth + 24 : grid.clientWidth;
        
        grid.style.scrollSnapType = 'none';
        grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        
        setTimeout(() => {
          grid.style.scrollSnapType = 'x mandatory';
        }, 500);
      });
      
      grid.addEventListener('scroll', updateNavButtons);
      window.addEventListener('resize', updateNavButtons);
      
      // Initial state
      updateNavButtons();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReelsNav);
  } else {
    initReelsNav();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('reels-section') || event.target.querySelector('.reels-section')) {
      initReelsNav();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
